module.exports = __webpack_public_path__ + "static/media/irori_sm3.52f0113d.gif";